<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="title"
    :items="grades"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    @update:search-input="update"
    clearable
    :loading="loading"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from 'vuex'
import { Grade } from '@/plugins/api'

export default {
  data: () => ({
    grades: [],
    loading: false,
  }),
  props: {
    filters: Object,
    defaultGrades: Array,
    options: Object,
  },
  computed: {
    ...mapGetters('auth', ['ownGradeIds']),
  },
  created() {
    if (this.defaultGrades) {
      this.grades = this.defaultGrades
    }

    this.fetchAllGrades()
  },
  methods: {
    async fetchAllGrades(query) {
      this.loading = true
      const params = {
        ...this.filters,
        ...query,
        _sort: 'gradeNumber:ASC',
        _limit: -1,
      }
      if (this.ownGradeIds) params['id_in'] = this.ownGradeIds
      this.grades = await Grade.fetch(params)
      this.loading = false
    },
    async update(data) {},
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filters(newVale) {
      if (newVale) this.fetchAllGrades(newVale)
    },
  },
}
</script>

<style scoped></style>
